/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import {
  Avatar,
  Badge,
  Box,
  Chip,
  Grid,
  ListItem,
  ListItemAvatar,
  Paper,
  Typography,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Spacer from '@app/components/atoms/Spacer';
import { parseMetadata, extractCleanImageUrls, extractCleanAudioUrls, extractCleanVideoUrls, extractNonMediaUrls } from './helper';
import MediaGrid from '../../GroupChat/MediaGrid';
import VideoPlayer from '../../GroupChat/VideoPlayer';
import ExpandedMediaModal from '../../GroupChat/ExpandedMediaModal';

const removeTimeStampFromFile = (filename) => filename?.replace(/-\d+$/, "") || "";
const MessageItem = ({
  msg,
  index,
  stableAuthUserId,
  chatState,
  theme,
  getUserRole,
  isUserOnline,
  expandedMedia,
  setExpandedMedia,
}) => {
  const isOwnMessage = msg.sender?.id === stableAuthUserId;
  const showAvatar =
    index === 0 ||
    chatState.groupChatMessages[index - 1]?.sender?.id !== msg.sender?.id;

  const userRole = getUserRole(msg.sender?.id);
  const online = isUserOnline(msg.sender?.id);

  const metadata = parseMetadata(msg?.metadata);
  const mediaUrls = metadata?.media_urls || [];

  const photoFilteredMediaUrls = extractCleanImageUrls(mediaUrls);
  const videoFilteredMediaUrls = extractCleanVideoUrls(mediaUrls);
  const audioFilteredMediaUrls = extractCleanAudioUrls(mediaUrls);
  const nonFilteredMediaUrls = extractNonMediaUrls(mediaUrls);

  return (
    <ListItem
      sx={{
        flexDirection: isOwnMessage ? "row-reverse" : "row",
        alignItems: "flex-start",
        pb: 0.5,
      }}
    >
      {showAvatar && (
        <ListItemAvatar
          sx={{
            minWidth: isOwnMessage ? 0 : 48,
            mr: isOwnMessage ? 0 : 1,
            ml: isOwnMessage ? 1 : 0,
          }}
        >
          <Badge
            variant="dot"
            color="success"
            invisible={!online}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Avatar src={msg.sender?.avatar?.thumb} sx={{ width: 32, height: 32 }}>
              {msg.sender?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
          </Badge>
        </ListItemAvatar>
      )}

      <Box
        sx={{
          maxWidth: "70%",
          ml: !showAvatar && !isOwnMessage ? 6 : 0,
          mr: !showAvatar && isOwnMessage ? 6 : 0,
        }}
      >
        {showAvatar && (
          <Box display="flex" alignItems="center" gap={1} mb={0.5}>
            <Typography variant="caption" fontWeight="bold">
              {isOwnMessage ? "You" : msg.sender?.name}
            </Typography>

            {userRole !== "MEMBER" && (
              <Chip
                label={userRole}
                size="small"
                color={userRole === "ADMIN" ? "primary" : "secondary"}
                sx={{ height: 16, fontSize: "0.65rem" }}
              />
            )}
          </Box>
        )}

        {msg.message && msg.message.trim() !== "" && (
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              backgroundColor: isOwnMessage
                ? theme.palette.primary.main
                : theme.palette.background.paper,
              color: isOwnMessage
                ? theme.palette.primary.contrastText
                : theme.palette.text.primary,
              borderRadius: 2,
              position: "relative",
            }}
          >
            <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
              {msg.message}
            </Typography>
          </Paper>
        )}

        {mediaUrls?.length > 0 && (
          <>
            <Spacer height="0.5rem" />
            <Grid container spacing={2}>
              {/* Images */}
              {photoFilteredMediaUrls?.length > 0 && (
                <Grid item xs={12}>
                  <MediaGrid
                    mediaUrls={photoFilteredMediaUrls}
                    setExpandedMedia={setExpandedMedia}
                  />
                  {expandedMedia.urls?.length > 0 && (
                    <ExpandedMediaModal
                      urls={expandedMedia.urls}
                      startIndex={expandedMedia.index}
                      onClose={() => setExpandedMedia({ urls: [], index: 0 })}
                    />
                  )}
                </Grid>
              )}

              {/* Videos */}
              {videoFilteredMediaUrls?.length > 0 && (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {videoFilteredMediaUrls?.map((url, idx) => (
                      <Grid item key={idx} xs={12}>
                        <VideoPlayer url={url} />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}

              {/* Audios */}
              {audioFilteredMediaUrls?.length > 0 && (
                <>
                  <Spacer height="0.5rem" />
                  <Grid container spacing={2}>
                    {audioFilteredMediaUrls?.map((url, idx) => (
                      <Grid item key={idx} xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            margin: "5px",
                            borderRadius: "10px",
                            overflow: "hidden",
                            cursor: "pointer",
                          }}
                        >
                          <audio controls style={{ width: "100%" }}>
                            <source src={url} type={`audio/${url?.split(".").pop()}`} />
                            Your browser does not support the audio tag.
                          </audio>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}

              {/* Files */}
              {nonFilteredMediaUrls?.length > 0 && (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    {nonFilteredMediaUrls?.map((url, idx) => {
                      const fileName = url && url?.split("/").pop();
                      return (
                        <Grid item key={idx} xs={12}>
                          <a
                            href={url}
                            download={fileName}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              display: "block",
                              cursor: "pointer",
                              textDecoration: "none",
                              color: "#000",
                            }}
                          >
                            <Grid
                              container
                              borderRadius="5px"
                              sx={{
                                border: "solid 2px rgba(113, 113, 113, 0.1)",
                                padding: "0.5rem",
                              }}
                            >
                              <Grid
                                item
                                xs={1}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <AttachFileIcon color="primary" />
                              </Grid>
                              <Grid
                                item
                                xs={11}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography
                                  variant="body1"
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {removeTimeStampFromFile(
                                    !!fileName && decodeURIComponent(fileName)
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </a>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </>
        )}
      </Box>
    </ListItem>
  );
};

export default MessageItem;
